/*
hdx-datagrid-directive.js

-GE CONFIDENTIAL-
Type: Source Code

Copyright (c) 2021, GE Healthcare Co.
All Rights Reserved

This unpublished material is proprietary to GE Healthcare. The methods and
techniques described herein are considered trade secrets and/or
confidential. Reproduction or distribution, in whole or in part, is
forbidden except by express written permission of GE Healthcare.
*/
/* global TrNgGrid:false */

define('modules/shell/widgets/datagrid/js/directive/hdx-datagrid-directive',['jquery', 'angular', 'angular-ui', 'tr-Ng-Grid-directive'], function ($, angular) {
    'use strict';

    angular.module('hdxDatagridModule', ['trNgGrid', 'ui.bootstrap'])
        .directive('hdxDatagrid', ['$templateCache', '$compile', '$http', '$timeout', function ($templateCache, $compile, $http, $timeout) {
            return {
                restrict: 'E',
                replace: 'true',
                transclude: true,
                scope: {
                    pageOptions: '=?',
                    noDataMsg: '=',
                    searchMsg: '=',
                    gridTemplateUrl: '=',
                    maxSize: '=',
                    boundaryLinks: '=',
                    rotate: '=',
                    previousText: '=',
                    nextText: '=',
                    firstText: '=',
                    lastText: '=',
                    numPages: '=',
                    searchLabel: '=',
                    searchPlaceHolderText: '=',
                    createButtonText: '=',
                    currentPageNumber: '=',
                    createNewItem: '&?',
                    infiniteScroll: '=?',
                    getDataOnScroll: '&?',
                    infiniteScrollingContainer: '@?',
                    noMoreData: '=?',
                    loadMsg: '=?',
                    showDataLoadMsg: '=?',


                    // Default Options from trNGGrid
                    items: '=',
                    selectedItems: '=?',
                    filteredItems: '=?',
                    filteredItemsPage: '=?',
                    filterBy: '=?',
                    filterByFields: '=?',
                    orderBy: '=?',
                    orderByReverse: '=?',
                    pageItems: '=?',
                    currentPage: '=?',
                    totalItems: '=?',
                    enableFiltering: '=?',
                    enableSorting: '=?',
                    selectionMode: '@',
                    locale: '@',
                    onDataRequired: '&',
                    onDataRequiredDelay: '=?',
                    fields: '=?',
                    onGridCellItemClickNotify: '&onGridCellItemClick'
                },
                template: '<div class="hdx-datagrid">' + '<div class="search-label">{{searchLabel}}</div>' + '<div class="datagrid-header-controls row"><div class="search-box pull-left" >' + '<div class="input-group ">' + '<input type="text" ng-model="globalFilter" placeholder="{{searchPlaceHolderText}}" class="input-sm form-control searchPlaceHolder"> ' + '<span class="input-group-btn">' + '<button id="searchBtn" class="btn btn-sm btn-icon"><i class="icon-ico_search_lg"></i></button> ' + '</span>' + '</div>' + '</div>' + '<div class="create-new-item pull-right">' + '<button class="btn btn btn-primary" ng-click="createNewItem()"><i class="icon-ico_add_rnd_sm"></i> {{createButtonText}}</button>' + '</div></div><div class="grid-container"></div><div ng-show="noMoreData" ng-transclude></div><div class="scrollMsgLoad" ng-show="showDataLoadMsg"><span class="loadingIndicatorStatus"><i class="icon-ico_spinner_sm"></i></span><span style="height:15px">{{loadMsg}}</span></div>' + '</div>',

                link: function (scope, ele, attr) {
                    var gridTemplate,
                        infiniteScrollTbodyCss = {
                            'display': 'block',
                            'overflow': 'auto',
                            'max-height': scope.infiniteScrollingContainer || '300px'
                        },
                        isGridInit = false;


                    function populateGrid() {
                        var $gridTemplate = $(gridTemplate);
                        var isInfiniteScrollEnabled = angular.isDefined(scope.infiniteScroll) && (attr.infiniteScroll === 'true' || scope.infiniteScroll === true);

                        if (isInfiniteScrollEnabled) {
                            $gridTemplate.removeAttr('page-items');
                            $gridTemplate.find('th').attr('cell-width', '1000px');
                            $gridTemplate.find('td').attr('cell-width', '1000px');
                        }
                        if (!scope.selectionMode) {
                            scope.selectionMode = 'MultiRow';
                        }
                        var compiledGridTemp = $compile($gridTemplate)(scope);

                        if (isInfiniteScrollEnabled) {
                            var tbody = compiledGridTemp.find('tbody');
                            tbody.css(infiniteScrollTbodyCss);
                            compiledGridTemp.find('thead').css({ display: 'block' });

                            tbody.scroll(function (event) {
                                if (event.target) {
                                    var target = $(event.target);
                                    if (target.scrollTop() + target.innerHeight() >= target[0].scrollHeight && scope.getDataOnScroll) {

                                        scope.getDataOnScroll();
                                    }
                                }
                                scope.$apply();
                            });
                        }
                        ele.find('.grid-container').append(compiledGridTemp);

                    }
                    scope.$watch('gridTemplateUrl', function (n) {
                        if (n && !isGridInit) {
                            $http.get(n, {
                                accept: 'text/html',
                                cache: $templateCache
                            }).then(function (res) {
                                gridTemplate = res.data;
                                if (gridTemplate) {
                                    populateGrid();
                                    isGridInit = true;
                                }
                            });
                        }
                    });

                    scope.setDataWidth = function () {
                        $timeout(function () {
                            $('.tr-ng-title').each(function () {
                                $(this).closest('th').css('min-width', (($(this).find('.column-title')[0]).scrollWidth + 55) + 'px');
                            });
                            $('.cell-data').css('max-width', $('.cell-data').closest('.tr-ng-cell').css('width'));
                        }, 10);
                    };
                    scope.onGridCellItemClick = function (gridItem) {
                        scope.onGridCellItemClickNotify({ selectedItem: gridItem });
                    };

                    scope.onStatusClick = function ($event, tooltipText) {
                        var $this = $($event.target);
                        $this.attr('data-original-title', tooltipText);
                        $this.tooltip({ placement: 'top', trigger: 'hover click touchstart', container: 'body' });
                        $this.tooltip('show');

                    };

                    scope.onMouseoverData = function ($event) {

                        var $this = $($event.target);
                        if($event.type && $event.type === 'click'){
                            $this.removeAttr('data-original-title');
                            if ($this.tooltip) {
                                $this.tooltip('hide');
                            }
                            return;
                        }

                        if ($this[0].offsetWidth < $this[0].scrollWidth) {
                            $this.attr('data-original-title', $this.text());
                            $this.tooltip({ placement: 'top', trigger: 'hover click touchstart', container: 'body' });
                            $this.tooltip('show');
                        }
                        else if ($this[0].offsetWidth >= $this[0].scrollWidth) {
                            $this.removeAttr('data-original-title');
                            if ($this.tooltip) {
                                $this.tooltip('hide');
                            }
                        }
                    };
                    $(window).resize(function () {
                        scope.setDataWidth();
                    });

                    $timeout(function () {
                        scope.setDataWidth();
                    }, 10);
                }
            };
        }]).run(['$templateCache', function ($templateCache) {
            TrNgGrid.defaultPagerMinifiedPageCountThreshold = 6;
            $templateCache.put('trNgGridPager.html', '<div class="trngpager"><div ng-show="gridOptions.enableFiltering" class="page-item pull-left"><span translate>hdx-table-items.show </span><select ng-model="gridOptions.pageItems" ' + 'ng-options="pageOption as pageOption for pageOption in pageOptions" class="" ng-change="currentPageNumber = 1; setDataWidth();"></select> <span translate>hdx-table-items.entries</span>' + '</div>' +
                '<div class="pull-right"> <div class="page-info-label pull-left"> <div ng-show="totalItemsCount">' + '{{startItemIndex+1}} - {{endItemIndex+1}} <b > <span translate>hdx-table-items.of </span> {{\'\'|' + TrNgGrid.translateFilter + ':gridOptions.locale}}</b>' + '<span><b> {{totalItemsCount}} {{\'\'|' + TrNgGrid.translateFilter + ':gridOptions.locale}}</b></span>' + '</div ></div > ' +
                ' <ul class="pagination">' + '   <li ng-class="{disabled:!pageCanGoBack}" ng-if="extendedControlsActive">' + '     <a href="" ng-click="pageCanGoBack&&navigateToPage(0)" ng-attr-title="{{\'First Page\'|' + TrNgGrid.translateFilter + ':gridOptions.locale}}">' + '         <span>{{firstText}}</span>' + '     </a>' + '   </li>' + '   <li ng-class="{disabled:!pageCanGoBack}" ng-if="extendedControlsActive">' + '     <a href="" ng-click="pageCanGoBack&&navigateToPage(gridOptions.currentPage - 1)" ng-attr-title="{{\'Previous Page\'|' + TrNgGrid.translateFilter + ':gridOptions.locale}}">' + '         <span>{{previousText}}</span>' + '     </a>' + '   </li>' + '   <li ng-if="pageSelectionActive" ng-repeat="pageIndex in pageIndexes track by $index" ng-class="{disabled:pageIndex===null, active:pageIndex===gridOptions.currentPage}">' + '      <a class="morepages" ng-if="pageIndex===null">...</a>' + '<a href="" ng-click="navigateToPage(pageIndex)" ng-if="pageIndex!==null" ng-attr-title="{{\'Page\'|' + TrNgGrid.translateFilter + ':gridOptions.locale}}">{{pageIndex+1}}</a>' + '   </li>' + '   <li class="disabled" style="white-space: nowrap;">' + '     <span ng-hide="totalItemsCount">{{\'hdx-table-items.noItemsToDisp\'|' + TrNgGrid.translateFilter + ':gridOptions.locale}}</span>' + '   </li>' + ' <li ng-class="{disabled:!pageCanGoForward}" ng-if="extendedControlsActive">' + '     <a href="" ng-click="pageCanGoForward&&navigateToPage(gridOptions.currentPage + 1)" ng-attr-title="{{\'Next Page\'|' + TrNgGrid.translateFilter + ':gridOptions.locale}}">' + '         <span>{{nextText}}</span>' + '     </a>' + '   </li>' + '   <li ng-class="{disabled:!pageCanGoForward}" ng-if="extendedControlsActive">' + '     <a href="" ng-click="pageCanGoForward&&navigateToPage(lastPageIndex)" ng-attr-title="{{\'Last Page\'|' + TrNgGrid.translateFilter + ':gridOptions.locale}}">' + '         <span>{{lastText}}</span>' + '     </a>' + '   </li>' + ' </ul>' + '</div></div>');

            $templateCache.put('trNgGridColumnSort.html', '<div ng-attr-title="{{\'Sort\'|' + TrNgGrid.translateFilter + ':gridOptions.locale}}" ng-show="(gridOptions.enableSorting&&columnOptions.enableSorting!==false)||columnOptions.enableSorting" class="' + TrNgGrid.columnSortCssClass + '" ></div>');

            $templateCache.put('trNgGridHeaderCellTemplate.html', '<div class="' + TrNgGrid.headerCellCssClass + '" ng-switch="isCustomized" >' + '  <div ng-switch-when="true">' + '    <div ng-transclude=""></div>' + '  </div>' + '  <div ng-switch-default><div class="' + TrNgGrid.columnTitleCssClass + '" ng-if="(gridOptions.enableSorting&&columnOptions.enableSorting!==false)||columnOptions.enableSorting"' + ' ng-click="toggleSorting(columnOptions.fieldName); setDataWidth();"' + '" ng-class="{\'' + 'sorted-column' + '\':gridOptions.orderBy==columnOptions.fieldName}"><span class="' + TrNgGrid.columnSortCssClass + '" > ' + '    <div class="column-title" ng-mouseenter="onMouseoverData($event)">  {{columnTitle |' + TrNgGrid.translateFilter + ':gridOptions.locale}}</div> <i ng-if="gridOptions.orderBy==columnOptions.fieldName&&!gridOptions.orderByReverse" class="icon-ico_arrowup_sm"></i><i ng-if="gridOptions.orderBy==columnOptions.fieldName&&gridOptions.orderByReverse" class="icon-ico_arrowdown_sm"></i></div><div class="' + TrNgGrid.columnTitleCssClass + '" ng-if="!gridOptions.enableSorting || columnOptions.enableSorting ===false"><div class="column-title" ng-mouseenter="onMouseoverData($event)"' + ' class="' + TrNgGrid.columnSortCssClass + '" >' + '      {{columnTitle |' + TrNgGrid.translateFilter + ':gridOptions.locale}} ' + '</div>' + '</div>' + '<div ' + TrNgGrid.columnSortDirectiveAttribute + '=""></div>' + '</div>' + '    <div ' + TrNgGrid.columnFilterDirectiveAttribute + '=""></div>' + '</div>');

        }]).filter('searchDataHighlight', ['$sce', function ($sce) {
            return function (data, phrase) {
                data = data + '';
                if (phrase) {
                    // datagrid search fix - escape special chars before creating regex
                    phrase = phrase.replace(/([.*+?^${}()|[\]/\\])/g, '\\$1');
                    data = data.replace(new RegExp('(' + phrase + ')', 'gi'), '<b><span class="search-color">$1</span><span></b>');
                }
                return $sce.trustAsHtml(data);
            };
        }]);

});


